<script>
import assetMaterialsHelper from "@/mixins/assetMaterialsHelper";
import {has, isObject, debounce} from 'lodash';

export default {
  mixins: [
    assetMaterialsHelper
  ],
  props: [
    'clientId',
  ],
  async mounted() {
    // Get CSRF token
    await this.requestGetCSRFtoken();
    await this.requestAutocompleteLocations();
  },
  data () {
    return {
      selectedItem: '',
      searchQuery: '',
      userCSRFToken: '',
      loading: false,
      suggestions: [],
    }
  },
  computed: {
    // pageCount () {
    //   return parseInt(this.dialogUsers.pager.total_pages);
    // },
  },
  watch: {
    searchQuery() {
     this.requestAutocompleteLocations();
    }
  },
  methods: {
    selectLocation(location) {
      // Check if the location is selected from the suggestions. We don't want the event to trigger on user text input.
      if (has(location, 'title')) {
        // Emit event
        this.getCoordinatesFromAddress(location);
      }
    },
    async getCoordinatesFromAddress(location) {
      const address = location.title;
      // Find the latlon from address
      let url = import.meta.env.VITE_API_BASEURL + 'ajax/address-to-latlon';
      let params = {
        query: address
      }
      // Fetch session token
      const response = await fetch(url + '?' + new URLSearchParams(params), {
        credentials: "include"
      })
      const response_json = await response.json();
      // Get coordinates
      const coordinates = response_json.coordinates;
      // Emit event with the coordinates
      this.$emit('location-selected', coordinates)
    },
    requestAutocompleteLocations: debounce(async function () {
      if (isObject(this.searchQuery)) {
        return; // If it's an object, the user has selected an item. Don't fetch new suggestions results.
      }
      this.loading = true;
      let url = import.meta.env.VITE_API_BASEURL + 'ajax/autocomplete-locations/vue';
      // Add client ID to autocomplete search suggestions if it's set
      if (this.clientId) {
        url += '/' + this.clientId;
      }
      let params = {
        query: this.searchQuery ?? ''
      }
      // Fetch session token
      const response = await fetch(url + '?' + new URLSearchParams(params), {
        credentials: "include"
      })
      const response_json = await response.json();
      // Set suggestions
      this.suggestions = response_json.suggestions;
      this.loading = false;
    }, 400),
  },
}
</script>

<template>

  <div>

    <v-combobox
      v-model="searchQuery"
      label="Zoek adres of plaatsnaam"
      aria-label="Zoek adres of plaatsnaam"
      role="search"
      :items="suggestions"
      no-filter
      variant="outlined"
      density="comfortable"
      :loading="loading"
      @update:model-value="selectLocation"
    >
      <template #item="{ props, item }">
        <v-list-subheader :class="['powered-by-google']" v-if="props.header">
          {{ props.header }}
        </v-list-subheader>
        <v-divider v-else-if="props.divider" class="mt-2" />
        <v-list-item v-else v-bind="props" density="compact"></v-list-item>
      </template>
    </v-combobox>
  </div>

</template>

<style lang="scss">
  .v-list-subheader {
    background: yellow;
  }
  .powered-by-google {
    background:  url('assets/powered-by-google-on-white.png') no-repeat center right;
  }
</style>
